<template>
	<div class="FundInfo">
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-moneynt Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 资金管理 / 资金明细</span>
		</div>
		<div
			class="companyOperatingRecordBox content_Box box-shadow m-t-15"
			:style="{ 'min-height': windowSizeHeight - 120 + 'px' }"
		>
			<div class="moneyShow">
				<el-row :gutter="10" class="title">
					<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
						<h4>账户总余额</h4>
					</el-col>
				</el-row>
				<el-row :gutter="10" class="content">
					<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
						<div>
							<b class="balance fl">￥{{ totle_balance | filterNumber }}</b>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="m-t-30">
				<div class="financialDetails_title">
					<b>开户税源地</b>
				</div>
				<template>
					<el-table :data="available_balance" stripe style="width: 100%;">
						<el-table-column label="开户税源地名称" prop="name"></el-table-column>
						<el-table-column label="开户行" prop="channel_name"> </el-table-column>
						<el-table-column label="专属账号">
							<template slot-scope="{ row, $index }">
								<span class="font-Tahoma">{{ row.bank_account | sub_blank }}</span>
							</template></el-table-column
						>
						<el-table-column label="账户余额" align="right" prop="operation_time">
							<template slot-scope="{ row, $index }">
								<span class="font-Tahoma text-color-red">{{ row.balance | filterNumber }}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" prop="desc">
							<template slot-scope="{ row, $index }">
								<a class="cz-font cursor-pointer cz-hd" @click="lookMoneyDetail(row.channel_id)">查看流水</a>
							</template>
						</el-table-column>
					</el-table>
				</template>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pageNum"
						:page-sizes="pageSize"
						:page-size="pageSizeNow"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { common } from '../../static/tool.js'
export default {
	name: 'FundInfo',
	data() {
		return {
			url: common.url,
			windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
			available_balance: [], //账户余额
			totle_balance: 0, //账户总资产
			//	分页
			total: 0, //总数
			pageNum: 1, //当前页
			pageSize: [10, 20, 50, 100, 200, 500], //每页展示条数
			pageSizeNow: 50 //当前每页多少行
		}
	},
	mounted() {
		this.startResult()
	},
	methods: {
		startResult() {
			if (!sessionStorage.getItem('userInfo')) {
				//是否登录
				window.location = 'login.html'
				return
			}
			this.getBalance()
		},
		getBalance() {
			//获取账户余额
			this.$http.post(this.url + '/zhongfy/company/getPayChannelList').then(
				res => {
					let data = res.data
					console.log(data)
					if (data.code == '200') {
						this.available_balance = data.data
						let totle_balance = 0
						for (let i = 0; i < this.available_balance.length; i++) {
							totle_balance = totle_balance + Number(this.available_balance[i].balance)
						}
						this.totle_balance = totle_balance.toFixed(2)
					} else if (data.code == '8886') {
						//code   8886  登录过期
						sessionStorage.clear()
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html'
							}
						})
						return
					} else {
						return
					}
				},
				err => {
					return
				}
			)
		},

		lookMoneyDetail(channel_id) {
			//查看流水
			console.log(channel_id)
			this.$router.push({
				path: '/fundInfoDetail',
				query: {
					channel_id: channel_id
				}
			})
		},

		handleCurrentChange(val) {
			//切换页数
			this.pageNum = val
		},
		handleSizeChange(val) {
			//切换每页条数
			this.pageSizeNow = val
			this.pageNum = 1
		}
	},
	filters: {}
}
</script>

<style scoped>
.demo-table-expand {
	font-size: 0;
	background: #f5f6fa;
	border: 1px solid #ebeef5;
	padding: 15px;
}

.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}

.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}

.financialDetails_title {
	height: 30px;
	font-size: 16px;
	padding-left: 10px;
	border-bottom: 1px solid #e8e8e8;
	color: #333333;
	margin-bottom: 15px;
}
.moneyShow {
	padding-left: 10px;
}
.moneyShow .content {
	height: 36px;
	line-height: 36px;
}
.moneyShow .title {
	line-height: 40px;
}
.moneyShow .content .balance {
	font-size: 30px;
	color: var(--theme-red);
	font-family: 'Impact', sans-serif;
}
.moneyShow .content .freeze {
	font-size: 30px;
	color: var(--zfy-blue);
}
</style>



// WEBPACK FOOTER //
// src/components/FundInfo.vue